@if (!items.length) {
  <p class="aal-empty">{{ emptyMessage }}</p>
} @else {
  <ul class="aal-list" [class.aal-list--compact]="compact">
    @for (item of items; track item.id) {
      <li>
        <a class="aal-item" [routerLink]="item.path" [queryParams]="item.query ?? null">
          <span [class]="severityClass(item.severity)">{{ item.severity }}</span>
          <span class="aal-body">
            <strong class="aal-title">{{ item.title }}</strong>
            <span class="aal-msg">{{ item.message }}</span>
          </span>
          @if (item.count > 0) {
            <span class="aal-count">{{ item.count }}</span>
          }
          <span class="aal-arrow" aria-hidden="true">→</span>
        </a>
      </li>
    }
  </ul>
}
